import {useMemo} from 'react';
import {DRIVER, NETWORK, SHOP} from "../../constants";
import {getDateFormat} from "../../utils/suitableDate";
import {DRIVER_INVOICE_DATE_FORMAT} from "../../constants/Invoice";
import {DriverInvoiceTemplateProps} from "./DriverInvoiceTemplate.view";

export type DriverServicePrice = {
    nbOrder: number;
    fixe: number;
    sumFee: number;
    subjectToVAT?: boolean;
    total: number;
    name?: string;
};

export type DriverInvoiceTemplateState = {
    emptyInvoice: boolean;
    driverItems: DriverServicePrice[];
    invoiceKey:string
};


export const useDriverInvoiceTemplate = (
    props: DriverInvoiceTemplateProps
): DriverInvoiceTemplateState => {
    const driverItems = useMemo<DriverServicePrice[]>(() => {
        const accountingInputs = props.billing?.accounting?.inputs ?? props.billing?.inputs ?? {};

        return Object.values(accountingInputs)
            .filter((input: any) => input?.type === DRIVER)
            .map((input: any) => {
                const amount = Number(input?.amount ?? 0);
                const subjectToVAT = Boolean(input?.data?.subjectToVAT);
                return {
                    nbOrder: 1,
                    fixe: amount,
                    sumFee: subjectToVAT ? amount * 1.2 : amount,
                    subjectToVAT,
                    total: 0
                };
            });
    }, [props.billing]);

    const invoiceKey = useMemo(() => {
        const { billing, dateInfo, shopId, isNetworkChecked } = props;

        const invoiceType = isNetworkChecked ? NETWORK : SHOP;
        const safeShopId = shopId?.toUpperCase?.() ?? '';
        const orderNumber = billing?.orderNumber ?? '';

        return `${getDateFormat(dateInfo as any, DRIVER_INVOICE_DATE_FORMAT)}${orderNumber}${safeShopId}${invoiceType.toUpperCase()}`;
    }, [
        props.billing?.orderNumber,
        props.dateInfo,
        props.shopId,
        props.isNetworkChecked
    ]);

    return {
        emptyInvoice: driverItems.length === 0,
        driverItems,
        invoiceKey
    };
};